export default __webpack_public_path__ + "static/prod8-61f62c060bc3461359d177064f1e1467.jpg";